module.exports = __webpack_public_path__ + "static/img/preview-03.722ace82.webp";